define.alias("shared/utils/hash-code", "settings/utils/hash-code");